import script from "./ChartOTRFiltered.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartOTRFiltered.vue?vue&type=script&setup=true&lang=js"

import "./ChartOTRFiltered.vue?vue&type=style&index=0&id=308e315d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-308e315d"]])

export default __exports__